import { render } from "./KnowledgebaseIndex.vue?vue&type=template&id=7d6c6bec"
import script from "./KnowledgebaseIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgebaseIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Knowledgebase/KnowledgebaseIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d6c6bec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d6c6bec', __exports__)) {
    api.reload('7d6c6bec', __exports__)
  }
  
  module.hot.accept("./KnowledgebaseIndex.vue?vue&type=template&id=7d6c6bec", () => {
    api.rerender('7d6c6bec', render)
  })

}


export default __exports__